import type { Reroute } from '@sveltejs/kit';
import { fetchCmsRouteInternalPath } from '$lib/cms-route';

export const reroute: Reroute = async ({ url, fetch }) => {
	return await fetchCmsRouteInternalPath({ url, fetch });
};
